import { render, staticRenderFns } from "./BarRaceChartOption.vue?vue&type=template&id=6afade9b&"
import script from "./BarRaceChartOption.vue?vue&type=script&lang=js&"
export * from "./BarRaceChartOption.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports